import {
  NavLink,
  Route,
  Routes,
  Outlet,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import { AppToaster } from "./components/common/Toaster";
import Login from "./components/Login";
import Register from "./components/Register";
import ForgotPassword from "./components/ForgotPassword";
import { isMobile } from "react-device-detect";
import UsersComponent from "./components/Users";
import Home from "./components/Home";
import Mercadopago from "./components/Mercadopago";
import MercadoPagoFailure from "./components/MercadoPagoFailure";
import MercadoPagoPending from "./components/MercadoPagoPending";
import MercadoPagoSuccess from "./components/MercadoPagoSuccess";
import SubscriptionSuccess from "./components/SubscriptionSuccess";
import ConfirmEmail from "./components/ConfirmEmail";
import Payments from "./components/Payments";
import Messaging from "./components/Messaging";
import ClinicalHistoryView from "./components/ClinicalHistoryView";
import ClinicalHistoryForm from "./components/ClinicalHistoryForm";
import ProfessionalSearch from "./components/ProfessionalSearch";

import InformedConsent from "./components/InformedConsent";
import CustomConsentEditor from "./components/CustomConsentEditor";
import CustomConsentViewer from "./components/CustomConsentViewer";

// import AppointmentsUsers from "./components/AppointmentsUsers";
// import AppointmentsProfessional from "./components/AppointmentsProfessional";

import MedicalHistory from "./components/MedicalHistory";
import Invite from "./components/Invite";
import Web from "./components/Web";
import Install from "./components/Install";
import Profile from "./components/Profile";
import Logout from "./components/Logout";
import _, { capitalize } from "lodash";
import React, { useState } from "react";
import { cn } from "./utils/utils";
import * as utils from "./utils/utils";
import "./App.css";
import config from "./config";
import {
  HouseIcon,
  UsersIcon,
  Calendar1Icon,
  CreditCardIcon,
  SettingsIcon,
  LogOutIcon,
  MailCheck,
} from "lucide-react";

import DoctorAppointments from "./components/DoctorAppointments";
import DoctorScheduleConfig from "./components/DoctorScheduleConfig";
import DoctorShareSchedule from "./components/DoctorShareSchedule";

import SecretarySharedSchedules from "./components/SecretarySharedSchedules";
import SecretaryAssignAppointments from "./components/SecretaryAssignAppointments";
import SecretaryDoctorSelection from "./components/SecretaryDoctorSelection";

import PatientBooking from "./components/PatientBooking";
import PatientAppointments from "./components/PatientAppointments";
import CancelAppointmentFromEmail from "./components/CancelAppointmentFromEmail";

import { useAuth } from "./lib/AuthContext";
import AfipConfiguration from "./components/AfipConfiguracion";
import InvoiceManagement from "./components/InvoiceManagement";
import WaitingRoomDoctor from "./components/WaitingRoomDoctor";
import WaitingRoomSecretary from "./components/WaitingRoomSecretary";
import ClinicalHistoryManagement from "./components/ClinicalHistoryManagement";
import InstitutionLanding from "./components/InstitutionLanding";
import AssociationLanding from "./components/AssociationLanding";
import AssociationMessaging from "./components/AssociationMessaging";
import AssociationSearch from "./components/AssociationSearch";
import DoctorAssociationMessages from "./components/DoctorAssociationMessages";
import AdminPanel from "./components/AdminPanel";
import InventoryHome from "./components/inventory/InventoryHome";
import SupplyForm from "./components/inventory/SupplyForm";
import TreatmentList from "./components/inventory/TreatmentList";
import TreatmentForm from "./components/inventory/TreatmentForm";
import ProfessionalAccessGate from "./components/ProfessionalAccessGate";
import LanguageSwitcher from "./components/common/LanguageSwitcher";
import UserMenu from "./components/common/UserMenu";

function getIconForMenuItem(item, userRole) {
  if (item === "turnos" && userRole) {
    return userRole === "association" ? <MailCheck /> : <Calendar1Icon />;
  }
  const icons = {
    home: <HouseIcon />,
    usuarios: <UsersIcon />,
    turnos: <Calendar1Icon />,
    agenda: <Calendar1Icon />,
    mercadopago: <CreditCardIcon />,
    profile: <SettingsIcon />,
    logout: <LogOutIcon />,
  };
  return icons[item];
}

function getPathForMenuItem(item, userRole) {
  if (item !== "turnos" || !userRole) {
    return `/${item}`;
  }
  const turnosPaths = {
    doctor: "/doctor/appointments",
    secretary: "/secretary/doctor-selection",
    institution: "/secretary/doctor-selection",
    association: "/association/messaging",
    patient: "/patient/search",
  };
  return turnosPaths[userRole] ?? `/${item}`;
}

function getMenu() {
  return ["home", "turnos", "profile", "logout"];
}

export default function App() {
  const { user, loading } = useAuth();
  const [searchParams] = useSearchParams();
  const inviteId = searchParams.get("inviteId") || null;
  let authUserToken = user;
  const authToken = localStorage.getItem("sb-peuhseswtlexeijsmmvu-auth-token");

  if (user === undefined || user === null) {
    authUserToken = authToken ? JSON.parse(authToken).user || null : null;
  }

  if (authUserToken === undefined || authUserToken === null) {
    return (
      <>
        <AppToaster />
        <Routes>
          <Route path="*" element={<Web />} />
          <Route path="login" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/invite" element={<Invite inviteId={inviteId} />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/confirm-email" element={<ConfirmEmail />} />
          <Route path="/install" element={<Install />} />
          <Route path="/cancel-appointment" element={<CancelAppointmentFromEmail />} />
        </Routes>
      </>
    );
  }

  return (
    <>
      <AppToaster withAppHeader />
      <Routes>
      <Route path="/">
        <Route element={<RootLayout />}>

          <Route path="login" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/invite" element={<Invite inviteId={inviteId} />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/confirm-email" element={<ConfirmEmail />} />
          <Route path="/install" element={<Install />} />
          <Route path="/cancel-appointment" element={<CancelAppointmentFromEmail />} />
          
          <Route index element={<Home />} />
          <Route path="profile" element={<Profile />} />
          <Route path="mercadopago" element={<Mercadopago />} />
          <Route path="payment-failure" element={<MercadoPagoFailure />} />
          <Route path="payment-pending" element={<MercadoPagoPending />} />
          <Route path="payment-success" element={<MercadoPagoSuccess />} />
          <Route path="subscription-success" element={<SubscriptionSuccess />} />
          <Route path="/mercadopago/:action" element={<Mercadopago />} />
          <Route path="usuarios" element={<UsersComponent />} />
          <Route path="home" element={<Home />} />
          <Route path="turnos" element={<Home />} />
          <Route path="doctor/schedule" element={<DoctorScheduleConfig />} />
          <Route path="doctor/appointments" element={<DoctorAppointments />} />
          <Route path="doctor/share" element={<DoctorShareSchedule />} />
          <Route path="doctor/clinical-history/add" element={<ClinicalHistoryForm />} />
          <Route path="doctor/clinical-history/view" element={<ClinicalHistoryView />} />
          <Route path="clinical-history/manage" element={<ClinicalHistoryManagement />} />
          <Route path="patient/search" element={<ProfessionalSearch />} />
          <Route path="institution/:institutionId" element={<InstitutionLanding />} />
          <Route path="association/:associationId" element={<AssociationLanding />} />
          <Route path="association/search" element={<AssociationSearch />} />
          <Route path="waiting-room-doctor" element={<WaitingRoomDoctor />} />
          <Route path="waiting-room-secretary" element={<WaitingRoomSecretary />} />
          <Route path="secretary/schedule" element={<SecretarySharedSchedules />} />
          <Route path="secretary/appointments" element={<SecretaryAssignAppointments />} />
          <Route path="secretary/doctor-selection" element={<SecretaryDoctorSelection />} />
          <Route path="patient/book" element={<PatientBooking />} />
          <Route path="patient/appointments" element={<PatientAppointments />} />
          <Route path="billing" element={<AfipConfiguration />} />
          <Route path="invoices" element={<InvoiceManagement />} />
          <Route path="informed-consent" element={<InformedConsent />} />
          <Route path="informed-consent/create" element={<CustomConsentEditor />} />
          <Route path="informed-consent/view/:id" element={<CustomConsentViewer />} />
          <Route path="informed-consent/edit/:id" element={<CustomConsentEditor />} />
          <Route path="payments/:appointmentId" element={<Payments />} />
          <Route path="historia-clinica/:userId" element={<MedicalHistory />} />
          <Route path="logout" element={<Logout />} />
          <Route path="install" element={<Install />} />
          <Route path="messaging" element={<Messaging />} />
          <Route path="association/messaging" element={<AssociationMessaging />} />
          <Route path="doctor/association-messages" element={<DoctorAssociationMessages />} />
          <Route path="admin" element={<AdminPanel />} />
          <Route path="inventory" element={<InventoryHome />} />
          <Route path="inventory/supplies/new" element={<SupplyForm />} />
          <Route path="inventory/supplies/:id/edit" element={<SupplyForm />} />
          <Route path="inventory/treatments" element={<TreatmentList />} />
          <Route path="inventory/treatments/new" element={<TreatmentForm />} />
          <Route path="inventory/treatments/:id/edit" element={<TreatmentForm />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
    </>
  );
}

function NotFound() {
  const location = useLocation();
  
  return (
    <div className="bg-black">
      <div className="w-9/12 m-auto py-16 min-h-screen flex items-center justify-center">
        <div className="bg-white shadow overflow-hidden sm:rounded-lg pb-8">
          <div className="border-t border-gray-200 text-center pt-8">
            <h1 className="text-9xl font-bold text-gray-400">404</h1>
            <h1 className="text-6xl font-medium py-8">
              Pagina no encontrada
            </h1>
            <p className="text-2xl pb-8 px-12 font-medium">
              Ups! La pagina que esta buscando no existe. Vuelva al
              inicio haciendo click en el boton.
            </p>
            <p className="text-xl pb-4 px-12 text-gray-600">
              Ruta actual: <span className="font-mono font-semibold">{location.pathname}</span>
            </p>
            <button
              className="bg-black hover:from-pink-500 hover:to-orange-500 text-white font-semibold px-6 py-3 rounded-md mr-6"
              onClick={() => window.location.assign("/")}
            >
              IR AL INICIO
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function RootLayout() {
  return (
    <Layout>
      <ProfessionalAccessGate>
        <Outlet />
      </ProfessionalAccessGate>
    </Layout>
  );
}

function getTheme() {
  return {
    primaryColor: `bg-[${config.theme.colors.primaryColor}]`,
    secondaryColor: `bg-[${config.theme.colors.secondaryColor}]`,
    secondaryBorder: `border-b-4 border-[${config.theme.colors.secondaryColor}]`,
    secondaryText: `text-[${config.theme.colors.secondaryColor}]`,
    textMenuBrandColor: `text-[${config.theme.colors.textMenuBrandColor}]`,
    textMenuColor: `text-[${config.theme.colors.textMenuColor}]`,
    textMenuHoverColor: `text-[${config.theme.colors.textMenuHoverColor}]`,
  };
}

function Layout({ children }) {
  const theme = getTheme();
  const { user } = useAuth();

  return (
    <div className="flex flex-col w-full h-screen text-gray-700 overflow-hidden">
      <nav
        className={cn(
          `shrink-0 flex justify-between items-center pr-6 w-full h-16 ${theme.textMenuColor} print:hidden ${theme.primaryColor} ${theme.secondaryBorder}`
        )}
      >
        <div
          className="flex gap-2 items-center cursor-pointer"
          onClick={() => window.location.assign("/")}
        >
          <div className="flex items-center">
            <img
              src={utils.getBrandLogoSrc()}
              alt="logo"
              className={cn("ml-4", utils.getBrandLogoClassName())}
            />
            {!utils.isBinapsisBrand() && (
              <h1
                className={`inline-block text-2xl sm:text-3xl ${theme.textMenuBrandColor} pl-2 tracking-tight`}
              >
                {config.brand}
              </h1>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2">
          <LanguageSwitcher variant="light" />
          {!isMobile && <UserMenu variant="light" />}
        </div>
      </nav>

      <main
        className={cn(
          "flex-1 min-h-0 overflow-y-auto overflow-x-hidden bg-gray-50",
          isMobile && "pb-16"
        )}
      >
        {children}
      </main>

      {isMobile && (
        <div
          className={cn(
            `fixed bottom-0 left-0 right-0 z-20 flex justify-between items-center h-14 ${theme.primaryColor} ${theme.textMenuColor} print:hidden w-full`
          )}
        >
          <div className="flex gap-4 mr-4 items-center justify-between w-full">
            {getMenu().map((el, i) => {
              const path = getPathForMenuItem(el, user?.role);
              return (
                <NavLink
                  key={i}
                  className={({ isActive }) =>
                    cn(
                      `h-full flex items-center px-4 hover:${theme.textMenuHoverColor} cursor-pointer`,
                      isActive && theme.secondaryText
                    )
                  }
                  to={path}
                >
                  {getIconForMenuItem(el, user?.role)}
                </NavLink>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

